import styled from 'styled-components';

export const ButtonRow = styled.div`
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    &.padding10 {
        padding: 0 10px;
    }

    &.autowidth {
        width: auto;
        flex: 1;
    }
`;

export const ButtonCol = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.padding10 {
        padding: 0 10px;
    }

    &.autowidth {
        width: auto;
        flex: 1;
    }
`;

export const Button = styled.div`
    flex: 1;
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color || '#fff'};
    color: ${props => props.color || '#fff'};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    :hover:not(.disabled) {
        background-color: ${props => props.color || '#fff'};
        color: #000;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }

    &.disabled {
        opacity: 0.4;
        cursor: default;
    }

    ${ButtonCol} & {
        margin-left: 0;
        margin-bottom: 10px;
        min-height: 30px;
    }

    ${ButtonCol} &:last-child {
        margin-bottom: 0;
    }
`;

export const ButtonIcon = styled(Button)`
    position: relative;
    flex: initial;
    width: 30px;

    &:before {
        content: '${props => props.icon || '\\F04E5'}';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const Icon = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    &:before {
        font-family: 'Material Design Icons';
        font-size: ${props => props.size || '24px'};
        color: ${props => props.color || '#fff'};
        content: '${props => props.icon}';
    }
`;